import styled from "styled-components/macro";

export const FooterWrapper = styled.footer`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0;
  background: #ff9767;
  color: #fff;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 70px 0;

  h3 {
    font-size: 28px;
    font-weight: lighter;
  }
  a {
    text-decoration: none;
    color: #fff;
    cursor: pointer;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  margin-top: 15px;

  .icon {
    font-size: 40px;
    margin: 5px;
  }
`;
